import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampusService {

  constructor(
    private http: HttpClient,
  ) { }

  // CAMPUS API
  getCampus(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/campuses', {withCredentials: true});
  }

  createCampus(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/campuses', JSON.stringify(item), {withCredentials: true});
  }

  updateCampus(item: any, campusId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/campuses/${campusId}`, JSON.stringify(item), {withCredentials: true});
  }

  // BUILDING API
  getBuildings(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/buildings', {withCredentials: true});
  }

  createBuilding(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/buildings', JSON.stringify(item), {withCredentials: true});
  }

  updateBuilding(item: any, buildingId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/buildings/${buildingId}`, JSON.stringify(item), {withCredentials: true});
  }

  // ROOMS API
  getRooms(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/rooms?include=building', {withCredentials: true});
  }

  getRoomsByUrl(url): Observable<any> {
    return this.http
    .get<any>(url, {withCredentials: true});
  }

  createRoom(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/rooms', JSON.stringify(item), {withCredentials: true});
  }

  updateRoom(item: any, roomId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/rooms/${roomId}`, JSON.stringify(item), {withCredentials: true});
  }

  // COLLEGE API
  getColleges(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/colleges', {withCredentials: true});
  }

  createCollege(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/colleges', JSON.stringify(item), {withCredentials: true});
  }

  updateCollege(item: any, collegeId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/colleges/${collegeId}`, JSON.stringify(item), {withCredentials: true});
  }

  // COURSE API
  getCourse(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/courses', {withCredentials: true});
  }

  createCourse(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/courses', JSON.stringify(item), {withCredentials: true});
  }

  updateCourse(item: any, courseId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/courses/${courseId}`, JSON.stringify(item), {withCredentials: true});
  }

   // DEPARTMENT API
  getDepartments(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/departments', {withCredentials: true});
  }

  createDepartment(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/departments', JSON.stringify(item), {withCredentials: true});
  }

  updateDepartment(item: any, departmentId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/departments/${departmentId}`, JSON.stringify(item), {withCredentials: true});
  }
}
